export enum FormType {
  ADD,
  EDIT,
  NONE,
}
